import Button from '@/shared/Button'

const TableTabButton = ({ selected, label, onClick }) => (
  <Button
    color={selected ? 'secondary_80' : 'white'}
    onClick={onClick}
    sx={{ border: '1px solid black', borderRadius: 0 }}
  >
    {label}
  </Button>
)

export default TableTabButton
